import { getChannelByUrl } from '../config';

export const useIsSeatGeek = (): boolean => {
    const salesChannelConfig = getChannelByUrl(window.location.host);
    const isSeatGeek = salesChannelConfig?.sso === 'seatgeek';

    return Boolean(isSeatGeek);
};
